<div class="skill-table">

  <p-table
    [columns]="skills"
    [scrollable]="true"
    [value]="filteredData"
    [autoLayout]="true"
    [tableStyle]="{ 'z-index': '0', 'position': 'relative' }"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th alignFrozen="left" pFrozenColumn pSortableColumn="team"
            style="min-width: 268px; max-width: 268px">Utente
          <p-sortIcon field="team" />
        </th>

        @for (col of skills; track col) {
          <th style="min-width: 168px; max-width: 168px">
            {{ col }}
          </th>
        }
      </tr>
      <tr class="table__subheader">
        <th alignFrozen="left" pFrozenColumn style="min-width: 268px; max-width: 268px">Categorie
          <i
            class="pi pi-info-circle ml-2"

            style="color: slateblue"
            pTooltip="Prima lettera:
              C = &quot;conosco&quot;, possiedo questa skill, ho esperienza professionalmente utile con questa tecnologia, ci so già fare le cose che di solito dobbiamo fare nei progetti su cui lavoriamo (report, CRUD, APIs, ...)
              N = &quot;non conosco&quot;, non possiedo questa skill, non ho mai visto né usato seriamente questa tecnologia, se dovessi usare questa skill non sarei autonomo da subito
              X  = &quot;non lo so&quot;, non riesco a posizionarmi o a decidere, o non voglio dirlo [usare per invocare una conversazione con il team]

              Seconda lettera:
              M = &quot;mi piace&quot;, sono contento di usarla, vorrei usarla, mi incuriosisce
              N = &quot;non mi piace&quot;, non mi attira, mi ha stancato, non mi incuriosisce
              X = &quot;non lo so&quot;, non ho un'opinione a riguardo, non ho abbastanza informazioni per decidere

              E' possibile eventualmente aggiungere in coda una terza lettera (non è obbligatorio):
              T = &quot;teacher&quot;, sono disponibile a fornire aiuto o consulenza su quell'argomento
              S = &quot;student&quot;, mi piacerebbe imparare, saperne di più, approfondire"
          ></i></th>

        @for (col of skills; track col) {
          <th style="min-width: 168px; max-width: 168px">
            <div class="cell-spacing">
              <div tooltipPosition="top" pTooltip="Conoscenze">C</div>
              <div tooltipPosition="top" pTooltip="Interesse">I</div>
              <div tooltipPosition="top" pTooltip="Formazione">F</div>
            </div>
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-columns="columns" let-rowData>
      <tr>
        <td pFrozenColumn style="min-width: 268px; max-width: 268px">
          <div class="align-items-center flex gap-3 hstack">
            <div
              class="user-propic"
              [ngStyle]="{  'background-image': rowData['user'].image    ? 'url(data:image/png;base64,' + rowData['user'].image + ')'    : 'none'}">
              <span *ngIf="!rowData['user'].image">
                {{ getInitials(rowData['user']) }}
              </span>
            </div>

            <div class="hstack">
              <div class="cell-username">{{ rowData['user'].name }}</div>
              <div class="cell-team">{{ rowData['year'] }}</div>
            </div>
          </div>
        </td>

        @for (col of columns; track col) {
          <td class="no-wrapped" style="min-width: 168px; max-width: 168px">
<!--            <span>{{ rowData['skills'][col].name }} {{ col }}</span>-->

            <div class="cell-spacing">
              @if (rowData['skills'][col]) {
                <div class="p-badge__wrap">
                  <div class="p-badge p-badge-circle" [ngClass]="getColor('knowledge', rowData['skills'][col].knowledge)">
                    <i tooltipPosition="top" pTooltip="{{getTooltipLabel('knowledge',rowData['skills'][col].knowledge)}}"
                       class="fa-solid" [ngClass]="getIcon('knowledge',  rowData['skills'][col].knowledge)"></i>
                  </div>
                </div>

                <div class="p-badge__wrap">
                  <div class="p-badge p-badge-circle" [ngClass]="getColor('like', rowData['skills'][col].like)">
                    <i tooltipPosition="top" pTooltip="{{getTooltipLabel('like', rowData['skills'][col].like)}}"
                       class="fa-solid" [ngClass]="getIcon('like',  rowData['skills'][col].like)"></i>
                  </div>
                </div>

                <div class="p-badge__wrap">
                  <div class="p-badge p-badge-circle"
                       [ngClass]="getColor('teaching_learning', rowData['skills'][col].teaching_learning)">
                    <i tooltipPosition="top"
                       pTooltip="{{getTooltipLabel('teaching_learning',rowData['skills'][col].teaching_learning)}}"
                       class="fa-solid"
                       [ngClass]="getIcon('teaching_learning',rowData['skills'][col].teaching_learning)"></i>
                  </div>
                </div>
              } @else {
                <span>-</span>
              }

            </div>
          </td>
        }

      </tr>
    </ng-template>
  </p-table>
</div>
